export enum SupportQuality {
  NEW = 'NEW',
  FIRST_CHOICE = 'FIRST_CHOICE',
  SECOND_CHOICE = 'SECOND_CHOICE',
  SECOND_CHOICE_NON_MECHANIZABLE = 'SECOND_CHOICE_NON_MECHANIZABLE',
  USED = 'USED',
  ALL_INCOMER = 'ALL_INCOMER',
  BROKEN = 'BROKEN'
}
